import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { templateContent } from 'lit/directives/template-content.js';
import { property, state } from 'lit/decorators.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import styles from './content-block.scss.js';
// NOTE: currently doesn't style as standalone component, styles come with the slots
export class ContentBlock extends CipublicElement {
    constructor() {
        super(...arguments);
        this.emitConnectedCallback = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
    }
    async firstUpdated() {
        var _a;
        await this.updateComplete;
        const contentContainer = this.parentNode;
        const gridContainer = contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.parentNode;
        if ((gridContainer === null || gridContainer === void 0 ? void 0 : gridContainer.hasAttribute('has-grid-background')) && (contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.firstElementChild) === this) {
            this.classList.add('has-grid-background');
        }
        if ((gridContainer === null || gridContainer === void 0 ? void 0 : gridContainer.hasAttribute('has-grid-background-container')) && (contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.firstElementChild) === this) {
            if (gridContainer === ((_a = gridContainer.parentElement) === null || _a === void 0 ? void 0 : _a.firstElementChild)) {
                this.classList.add('has-grid-background-container');
                if (contentContainer !== gridContainer.firstElementChild) {
                    this.classList.add('grid-background-mobile');
                }
            }
        }
    }
    render() {
        return !this._template ? html `<slot></slot>` : templateContent(this._template);
    }
}
ContentBlock.styles = styles;
__decorate([
    state()
], ContentBlock.prototype, "_template", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], ContentBlock.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=content-block.js.map